import React from 'react';
import '../css/dataTables.css';

const renderTableBody = (data, action) => {
    let body = "";

    body = data?.map((register, index) => {

        return (
            <tr key={index}>
                <td style={{ textAlign: "center", width: 100, maxWidth: 100 }}>
                    <button
                        type="button"
                        className="btn btn-sm"
                        onClick={() => action({ pk_UserID: register.pk_UserID })}
                        style={{
                            fontWeight: '500',
                            backgroundColor: "transparent",
                            color: "#EABF28"
                        }}
                    >
                        <i className="fas fa-check"></i>
                    </button>
                </td>

                <td style={{ whiteSpace: 'nowrap' }}>
                    {register?.USER_CODE ?? ""}
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                    {register?.U_NAME ?? ""}
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                    {register?.SucursalName ?? ""}
                </td>
            </tr>
        );
    });

    return body;
};

const renderTable = (headers, data, action, switch1) => {

    let header = "";
    let body = "";

    if (headers?.length > 0) {
        header = (
            <tr>
                <td className="sticky-header table-header-yellow" style={{ width: 100, maxWidth: 100 }}></td>
                {headers?.map((h, index) => (
                    <td key={index} className="sticky-header table-header-yellow">
                        {h.title}
                    </td>
                ))}
            </tr>
        );
    }

    body = renderTableBody(data, action);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%' }}>
                <thead className="table-header">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableCutTransfersUsersModal = (headers, data, action) => {

    return renderTable(headers, data, action);

}
